import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcHome(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.865 4.368a1.25 1.25 0 0 0-1.73 0l-6.25 5.99a1.25 1.25 0 0 0-.385.902V20c0 .139.112.25.25.25H8.5a.25.25 0 0 0 .25-.25v-3.5a3.25 3.25 0 0 1 6.5 0V20c0 .139.112.25.25.25h3.75a.25.25 0 0 0 .25-.25v-8.74c0-.341-.14-.667-.385-.903zm-2.768-1.083a2.75 2.75 0 0 1 3.806 0l6.25 5.99A2.75 2.75 0 0 1 21 11.26V20a1.75 1.75 0 0 1-1.75 1.75H15.5A1.75 1.75 0 0 1 13.75 20v-3.5a1.75 1.75 0 1 0-3.5 0V20a1.75 1.75 0 0 1-1.75 1.75H4.75A1.75 1.75 0 0 1 3 20v-8.74c0-.75.306-1.467.847-1.986z",
    clipRule: "evenodd"
  }));
}
var IcHome = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHome));

export { IcHome as I };
